import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g>
      <path
        d="M2.02149 15.2134C2.24168 17.2716 3.89697 18.9269 5.95405 19.1561C9.11375 19.5083 12.1867 19.5083 15.3464 19.1561C17.4035 18.9269 19.0588 17.2716 19.279 15.2134C19.4415 13.6941 19.5788 12.1343 19.5788 10.5441C19.5788 8.95388 19.4415 7.39408 19.279 5.87478C19.0588 3.81671 17.4035 2.16141 15.3464 1.93212C12.1867 1.57992 9.11375 1.57992 5.95405 1.93212C3.89697 2.16141 2.24168 3.81671 2.02149 5.87478C1.85894 7.39408 1.72168 8.95388 1.72168 10.5441C1.72168 12.1343 1.85894 13.6941 2.02149 15.2134Z"
        fill="white"
        stroke="#070F21"
      />
      <path d="M13.1758 8.01953L8.125 13.0703" stroke="#070F21" strokeLinecap="round" />
      <path d="M13.1758 13.0703L8.125 8.01953" stroke="#070F21" strokeLinecap="round" />
    </g>
    <defs>
      <rect width="20" height="20" fill="white" transform="translate(0.650391 0.544922)" />
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const DeleteFile = memo(ForwardRef);
export default DeleteFile;
